import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16825 Lead Finder — the keys that say "this location is already one of
 * our clients or leads", one row per (client, key).
 *
 * A derived cache, rebuilt from the tenant's own client, client_address,
 * client_license and client_license_match rows by LeadFinderKeyService (in
 * full once a day, incrementally for clients changed since the last refresh).
 * The Lead Finder list compares these against the matching integer columns of
 * workd_mission_control.lm_lead_location, so only this tenant's data ever
 * decides what is "new" for this tenant.
 *
 * keyType / keyHash:
 *   REG     — keyHash is the lm_registry id of a license linked to, or
 *             matched (confirmed or pending) to, the client. Exact.
 *   LIC     — keyHash(LIC, STATE|normalized number) of a client license. Exact.
 *   ADDR    — keyHash of the client's or any client address's address key.
 *   PHONE   — keyHash of the client's ten-digit phone.
 *   NPI     — keyHash of the client's NPI.
 *   NAMEZIP — keyHash of name (and DBA / legal name) + ZIP5.
 * The hash rule lives in apps/crm-api/src/modules/lead-finder/lead-finder-keys.ts
 * and is locked to the mission-control builder by a shared vectors file.
 *
 * Not audited: it is a cache whose every row can be recomputed from audited
 * tables, and a full rebuild rewrites ~150K rows for the largest tenant.
 */
@Index('idx_lead_finder_key_lookup', ['keyType', 'keyHash'])
@Index('uq_lead_finder_key', ['fkClientId', 'keyType', 'keyHash'], { unique: true })
@Entity('lead_finder_client_key', {}, { auditable: false })
export class LeadFinderClientKeyEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'keyType', length: 8 })
	public keyType!: string;

	/** BIGINT UNSIGNED — TypeORM returns it as a string. */
	@Column('bigint', { name: 'keyHash', unsigned: true })
	public keyHash!: string;
}
